export default (that) => [
  {
    text: that.$l('btn_delete') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
  },
]
